import script from "./HeaderView.vue?vue&type=script&setup=true&lang=js"
export * from "./HeaderView.vue?vue&type=script&setup=true&lang=js"

import "./HeaderView.vue?vue&type=style&index=0&id=083f5360&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-083f5360"]])

export default __exports__